<template>
  <div :class="['info_main',mode+'_mode']" ref="info_main">
    <!-- 导航 -->
    <div class="header" ref="header">
        <h1 v-for="(item,i) in tab" :class="[active == i ? 'active':'']" 
            @click="scrollTo(i)">
            {{ item.name  }}
        </h1>
    </div>

    <!-- 公司资料 -->
    <div ref="company">
        <company :company="company" :link1="link1"></company>
    </div>
    
    <div class="line"></div>

    <!-- 股东人数 -->
    <div ref="stock">
        <chart :price="price" :ratio="ratio"></chart>
    </div>
    
   

    <!-- 股东持股明细 -->
    <table1 :link2="link2" @done="done"></table1>

    <div class="line"></div>

    <!-- 题材板块 -->
    <div ref="plate">
        <plate :plate_list="plate_list"></plate>
    </div>
    

    <!-- 题材亮点 -->
    <point :light="light"></point>

    <!-- 题材详情 -->
    <page :info="info"></page>

  </div>
</template>

<script>
import "@/utils/flexible";
import company from './components/company.vue';//公司资料
import chart from './components/chart.vue';//股东人数
import table1 from './components/table1.vue';//股东持股明细
import plate from './components/plate.vue';//题材板块
import point from './components/point.vue';//题材亮点
import page from './components/page.vue';//题材详情
export default {
    components:{
        company,
        chart,
        table1,
        plate,
        point,
        page,
    },
    data(){
        return{
            tab:[
                {
                    name:'公司资料',
                    ref:'company',
                },
                {
                    name:'股本股东',
                    ref:'stock',
                },
                {
                    name:'概念题材',
                    ref:'plate',
                }
            ],
            active:0,
            mode:this.$route.params.mode,//light,dark
            code:this.$route.params.code,//sz000070

            link1:'',//公司链接
            link2:'',//股本股东链接


            //题材板块
            plate_list: [],

            //题材亮点
            light:[],

            //题材详情
            info:[],

            cureentDefault:'',

            //公司资料
            company:{},

            //图表
            shareholder_number:[],

            loading2:false,

            scroll:this.$route.query.scroll,
        }
    },
    created() {
        console.log(this.$route.params);
        //给app调用的方法
        let _this = this;
        window.scrollToTab = function(i){
            setTimeout(() => {
                _this.$nextTick(()=>{
                    _this.scrollTo(i,'ios');
                })
            }, 100);
        }

        let _host = location.host, _currentDefault;
        if(_host.indexOf("dev") > -1 || _host.indexOf("192.168") > -1) {
            _currentDefault = "dev"
        } else if(_host.indexOf("beta") > -1) {
            _currentDefault = "beta"
        } else {
            _currentDefault = ""
        }
        this.cureentDefault = _currentDefault;
        this.symbol = this.code.replace(/[^0-9]/ig, '');

        this.link1='http://basic.10jqka.com.cn/mobile/'+this.symbol+'/profilen.html',//公司链接
        this.link2='http://basic.10jqka.com.cn/mobile/'+this.symbol+'/holdern.html',//股本股东链接

        this.getTheme();
        this.getCompany();
    },
    mounted(){
    },
    methods:{
        scrollTo(i,kind){

            if(this.loading){
                return false;
            }

            var u = navigator.userAgent;
            var isAndroid = u.indexOf("Android") > -1 || u.indexOf("Linux") > -1; //android终端或者uc浏览器
            var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端

            let ref = this.tab[i].ref;
            if (isAndroid) {
                //安卓
                let h = this.$refs[ref].offsetTop;
                //this.$goAppLink('scroll',`&scroll=${h}`);

                this.$srH5CallNativeMethodApp('scroll',{
                    scroll: h,
                })
            }
            else{
                //无固定
                if(kind){
                    this.$refs[ref].scrollIntoView();
                }
                else{
                    //this.$goAppLink('scroll',`&scroll_tab=${i}`);

                    this.$srH5CallNativeMethodApp('scroll',{
                        scroll_tab: i,
                    })
                }
                
            }

            //固定
            // this.active = i;
            // let height= this.$refs.header.offsetHeight;
            // let h = this.$refs[ref].offsetTop;
            // document.body.scrollTop = document.documentElement.scrollTop = h - height;

        },
        getTheme(){
            let _this = this;
            $.ajax({
                xhrFields: { withCredentials: true },
                type: "get",
                url: `https://apis${this.cureentDefault}.aigupiao.com/Theme/stock_theme?symbol=${this.symbol}&stock_code=${this.code}&appversion=11.2.0&source=h5`,
                cache: false,
                async: true,
                error: function () {
                    return false;
                },
                success: function (res) {
                    console.log(res);
                    if(res.rslt=="succ"){
                        _this.plate_list = res.theme;
                        _this.light = res.light;
                        _this.info = res.info;
                    }                    
                },
            })
        },
        getCompany(){
            // https://appdev.aigupiao.com/goapi/stock/getCompanyInfo?stock_code=sh600715
            let _this = this;
            $.ajax({
                xhrFields: { withCredentials: true },
                type: "get",
                url: `https://app${this.cureentDefault}.aigupiao.com/goapi/stock/getCompanyInfo?stock_code=${this.code}`,
                cache: false,
                async: true,
                error: function () {
                    return false;
                },
                success: function (res) {
                    console.log(res);
                    if(res.code==1){
                        _this.company = res.data.company;
                        let _arr = [];
                        let len = res.data.shareholder_number && res.data.shareholder_number.length;
                        for(let i = len-1;i>=0;i--){
                            _arr.push(res.data.shareholder_number[i]);
                        }
                        _this.shareholder_number = _arr;
                        if(_this.company.ISSUE_PRICE && _this.company.AFTER_ISSUE_PE){
                            _this.company.ISSUE_PRICE_AFTER_ISSUE_PE = 
                            _this.company.ISSUE_PRICE +'元/' + _this.company.AFTER_ISSUE_PE+'倍';
                        }
                        
                    }                    
                },
            })
        },
        done(){
            this.loading2 = false;
        }
    },
    computed:{
        loading(){
            //全部加载完毕之后再跳转
            if(
                this.plate_list.length > 0
                &&
                this.shareholder_number.length > 0
                &&
                !this.loading2
                ){
                    return false;
                }
                else{
                    return true;
                }
        },
        ratio(){
            if(this.shareholder_number.length > 0){
                let arr = JSON.parse(JSON.stringify(this.shareholder_number));
                return arr.map((item)=>{
                    item.x = item.date;
                    item.y = parseFloat(item.shareholder_number/10000);
                    return item;
                })
            }
        },
        price(){
            if(this.shareholder_number.length > 0){
                let arr = JSON.parse(JSON.stringify(this.shareholder_number));
                return arr.map((item)=>{
                    item.x = item.date;
                    item.y = item.price;
                    return item;
                })
            }
        },

    },
    watch: {
        loading: {
            handler(newValue, oldValue) {
                if(!newValue){
                    if(this.scroll>=0){
                        setTimeout(() => {
                            this.$nextTick(()=>{
                                this.scrollTo(this.scroll);
                            })
                        }, 100);
                        
                    }
                }
            },
            deep: true//监听父组件数据变化
        },
    }
    
}
</script>

<style lang="scss" scoped>
    @import "~@/assets/sass/globalapp.scss";
    //两套样式 一套深色模式

    *{
        touch-action:unset!important;
    }
    .info_main{
        //固定 安卓无法固定
        // padding-top: rem2(52px);
        // .header{
        //     position: fixed;
        //     top: 0;
        //     width: 100%;
        //     box-sizing: border-box;
        //     z-index: 1;
        // }
        .header{
            display: flex;
            padding: rem2(10px);

            >h1{
                display: flex;
                padding: rem2(6px) rem2(10px);
                justify-content: center;
                align-items: center;
                flex: 1 0 0;
                font-size: rem2(14px);
                border-radius: rem2(4px);
                border: rem2(1px) solid #DCDCDC;
                margin-left: rem2(10px);
                &.active{
                    color: #FE484A;
                    border-color: #FE484A;
                }

                &:first-of-type{
                    margin-left: 0;
                }
            }
        }

        .line{
            height: rem2(10px);
        }
    }
    

</style>

<style lang="scss">
    @import "~@/assets/sass/globalapp.scss";
    .info_main{
        font-size: rem2(13px);
        .title1{
            font-size: rem2(14px);
            font-weight: 600;
        }
    }

    .light_mode{
        color: #333;
        background: #FFF;
        
        .header{
            background: #FFF;
        }

        .line{
            background: #F5F6F7;
        }

        .color63{
            color:#636363;
        }
        .color50{
            color: #507DAF;
            svg{
                fill: #507DAF;
            }
            
        }

        .title1{
            color: #333;
        }

        .green{
            color:#659957;
        }
        .red{
            color: #CB382D;
        }
    }

    .dark_mode{
        color:#F3F3F3;
        background: #121212;
        .header{
            background: #121212;
            >h1{
                border-color: rgba(220, 220, 220, 0.35);
                color: #F3F3F3;
                &.active{
                    color: #FF443D;
                    border-color: #FF443D;
                }
            }

        }

        .line{
            background: #000;
        }

        .color63{
            color:#B7B7B7;
        }

        .color50{
            color: #659BD6;
            svg{
                fill: #659BD6;
            }
            
            
        }

        .green{
            color:#36A758;
        }
        .red{
            color: #FF443D;
        }
    }


</style>